










import { Component, Prop, Vue } from 'vue-property-decorator';
import { AnsversType } from './types';

@Component
export default class ComponentsAnketaComponentsResult
 extends Vue {
  @Prop({type: Array, default: null})
  answers: AnsversType;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/anketaresult/Result.vue